// extracted by mini-css-extract-plugin
export default {"custom-map-pin":"MapboxMapView_custom-map-pin__Ce6Tv","custom-map-pin-number":"MapboxMapView_custom-map-pin-number__+wSiw"};